import React from "react";
import { Button, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const CustomButton = ({
  children,
  variant = "contained",
  color = "primary",
  size = "medium",
  onClick,
  disabled = false,
  startIcon,
  endIcon,
  loading = false,
  fullWidth = false,
  sx = {},
  className = "",
  loadingText,
  ...props
}) => {
  const theme = useTheme();

  const isDisabled = disabled || loading;

  return (
    <Button
      variant={variant}
      color={color}
      size={size}
      onClick={onClick}
      disabled={isDisabled}
      fullWidth={fullWidth}
      className={className}
      disableElevation   // 👈 IMPORTANT (let theme control shadows)

      startIcon={
        loading ? (
          <CircularProgress size={16} color="inherit" />
        ) : (
          startIcon
        )
      }
      endIcon={!loading ? endIcon : null}

      sx={{
        borderRadius: theme.shape.borderRadius * 1,

        // subtle interaction only (DO NOT override theme styles)
        "&:active": {
          transform: "scale(0.98)",
        },

        ...(isDisabled && {
          opacity: 0.7,
          pointerEvents: "none",
        }),

        ...sx,
      }}
      {...props}
    >
      {loading ? loadingText || children : children}
    </Button>
  );
};

export default CustomButton;